import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@bingads-webui-react/with-responsive-size';
import { ProcessingAnimation } from '@bingads-webui-campaign-react/processing-animation';
import { useWizardService, getWizardData } from '@bingads-webui-react/wizard';

const getStyles = () => ({
  animationContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    overflow: 'auto',
    background: '#ffffff',
    backgroundImage: 'radial-gradient(at 2.7% 92.9%, hsl(200, 35%, 93%) 0px, transparent 50%),radial-gradient(at 100.2% 77.6%, hsl(200, 35%, 93%) 0px, transparent 50%),radial-gradient(at 1.3% 13.0%, #f0f3f5 0px, transparent 50%),radial-gradient(at 55.5% 13.8%, #fcf9f5 0px, transparent 50%),radial-gradient(at 55.7% 72.1%, #ffffff 0px, transparent 50%),radial-gradient(at 96.0% 12.2%, hsl(200, 35%, 93%) 0px, transparent 50%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1100, // To cover the ui-blocker
    '& .processing-animation-container': {
      width: 700,
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      padding: '30px 60px',
      background: '#FFFFFF',
      boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
      borderRadius: '2px',
    },
  },
  'animationContainer-l': {
    '& .processing-animation-container': {
      width: 618,
    },
  },
  'animationContainer-m': {
    '& .processing-animation-container': {
      width: 424,
      padding: 20,
    },
  },
  'animationContainer-s': {
    '& .processing-animation-container': {
      width: 312,
      padding: 16,
    },
  },
});

export const AnimationBlockerView = (props) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);

  return (
    <div className={classNames('animation-blocker', classes.animationContainer, classes[`animationContainer-${displayMode}`], props.className)}>
      <ProcessingAnimation
        title={props.title || i18n.getString(_TL_('Creating your campaign...'))}
        description={props.description ||
          i18n.getString(_TL_('Give us a moment while we get everything set up for you.'))}
        rollingTexts={props.rollingTexts || [
          i18n.getString(_TL_('Setting up your advertising campaign...')),
          i18n.getString(_TL_('Almost ready...')),
        ]}
        showIcon={props.showIcon != null ? props.showIcon : true}
        useProgressIndicator={props.useProgressIndicator != null ? props.useProgressIndicator : true}
        displayMode={displayMode}
      />
    </div>
  );
};

AnimationBlockerView.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  rollingTexts: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  showIcon: PropTypes.bool,
  useProgressIndicator: PropTypes.bool,
};

AnimationBlockerView.defaultProps = {
  title: '',
  description: '',
  rollingTexts: null,
  className: '',
  showIcon: null,
  useProgressIndicator: null,
};

export const AnimationBlocker = (props) => {
  const { state } = useWizardService();
  const { isShowingAnimation } = getWizardData(state);

  if (!isShowingAnimation) {
    return null;
  }

  return <AnimationBlockerView {...props} />;
};
